import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faSearch,
    faEllipsisH,
    faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import {
    Breadcrumb,
    ButtonGroup,
    Button,
    InputGroup,
    Form,
    Card,
    Table,
    Dropdown,
    Spinner,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function TransaksiApprovalPage() {
    const history = useHistory();
    const [transaksiList, setTransaksiList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Sesi kamu telah berakhir, silakan login kembali.");
            history.push("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);

            if (decoded.exp * 1000 < Date.now()) {
                localStorage.removeItem("token");
                alert("Token kamu sudah kedaluwarsa, silakan login ulang.");
                history.push("/login");
                return;
            }

            setUserRole(decoded.role);
        } catch (err) {
            console.error("Token invalid:", err);
            localStorage.removeItem("token");
            history.push("/login");
        }
    }, [history]);

    const fetchTransaksi = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Sesi kamu telah berakhir, silakan login kembali.");
            history.push("/login");
            return;
        }

        const decoded = jwtDecode(token);
        const userId = decoded.user_id;
        const role = decoded.role;

        try {
            const url =
                role === "admin"
                    ? `${process.env.REACT_APP_API_URL}/transaksi`
                    : `${process.env.REACT_APP_API_URL}/transaksi/${userId}`;

            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Gagal memuat data transaksi");
            }

            const data = await response.json();
            setTransaksiList(data);
        } catch (error) {
            console.error("Gagal mengambil data transaksi:", error);
        } finally {
            setLoading(false);
        }
    };


    // 🗑️ Hapus transaksi (admin only)
    const handleApproval = async (id, approval) => {
        const yakin = window.confirm(`Apakah kamu yakin ingin meng approve transaksi ID ${id}?`);
        if (!yakin) return;

         const newApproval = !approval;

        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/approval-transaksi/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                      body: JSON.stringify({ approval: newApproval }),
         
            });

            if (response.ok) {
                alert("Transaksi berhasil di approve ");
                fetchTransaksi();
            } else {
                const text = await response.text();
                alert(`Gagal meng approve transaksi: ${text}`);
            }
        } catch (error) {
            console.error("Gagal meng approve transaksi:", error);
            alert("Terjadi kesalahan saat meng approve transaksi ");
        }
    };

    useEffect(() => {
        fetchTransaksi();
    }, []);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <Breadcrumb className="d-none d-md-inline-block breadcrumb-dark breadcrumb-transparent">
                        <Breadcrumb.Item>
                            <FontAwesomeIcon icon={faHome} />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Volt</Breadcrumb.Item>
                        <Breadcrumb.Item active>Approval Transaksi</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Daftar Approval Transaksi</h4>
                    <p className="mb-0">Data Approval transaksi.</p>
                </div>

                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => history.push("/transaksi/add")}
                        >
                            Tambah
                        </Button>
                    </ButtonGroup>
                </div>
            </div>

            <div className="table-settings mb-4">
                <InputGroup style={{ maxWidth: "400px" }}>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <Form.Control type="text" placeholder="Cari transaksi..." />
                </InputGroup>
            </div>

            <Card border="light" className="table-wrapper table-responsive shadow-sm">
                <Card.Body>
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" />
                        </div>
                    ) : transaksiList.length === 0 ? (
                        <p className="text-center mt-4">Tidak ada data transaksi.</p>
                    ) : (
                        <Table hover className="align-items-center">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nama User</th>
                                    <th>Nama Produk</th>
                                    <th>Quantity</th>
                                    <th>Total</th>
                                    <th>Approval</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transaksiList.map((trx) => (
                                    <tr key={trx.id}>
                                        <td>{trx.id}</td>
                                        <td>{trx.User?.nama || "-"}</td>
                                        <td>{trx.Produk?.nama || "-"}</td>
                                        <td>{trx.quantity}</td>
                                        <td>{trx.total.toLocaleString("id-ID")}</td>
                                        <td>{trx.approval ? "Disetujui" : "Belum disetujui"}</td>
                                        <td>
                                            <Dropdown as={ButtonGroup}>
                                                <Dropdown.Toggle
                                                    as={Button}
                                                    split
                                                    variant="link"
                                                    className="text-dark m-0 p-0"
                                                >
                                                    <span className="icon icon-sm">
                                                        <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
                                                    </span>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => handleApproval(trx.id, trx.approval)}
                                                    >
                                                        <FontAwesomeIcon icon={faThumbsUp} className="me-2" /> {trx.approval ? "Belum disetujui" : "Disetujui"}
                                                    </Dropdown.Item>

                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>
        </>
    );
}
